const fareharborTheme = {
  "--bds-border-200": "2px",
  "--bds-border-100": "1px",
  "--bds-palette-yellow-500": "#EAB308",
  "--bds-palette-yellow-300": "#FDE047",
  "--bds-palette-yellow-100": "#FEF9C3",
  "--bds-palette-yellow-200": "#FEF08A",
  "--bds-palette-emerald-500": "#10B981",
  "--bds-palette-emerald-300": "#6EE7B7",
  "--bds-palette-emerald-100": "#D1FAE5",
  "--bds-palette-emerald-200": "#A7F3D0",
  "--bds-palette-fuchsia-500": "#D946EF",
  "--bds-palette-fuchsia-300": "#F0ABFC",
  "--bds-palette-fuchsia-100": "#FAE8FF",
  "--bds-palette-fuchsia-200": "#F5D0FE",
  "--bds-palette-green-500": "#22C55E",
  "--bds-palette-green-300": "#86EFAC",
  "--bds-palette-green-100": "#DCFCE7",
  "--bds-palette-green-200": "#BBF7D0",
  "--bds-palette-indigo-500": "#6366F1",
  "--bds-palette-indigo-300": "#A5B4FC",
  "--bds-palette-indigo-100": "#E0E7FF",
  "--bds-palette-indigo-200": "#C7D2FE",
  "--bds-palette-lime-500": "#84CC16",
  "--bds-palette-lime-300": "#BEF264",
  "--bds-palette-lime-100": "#EBFACA",
  "--bds-palette-lime-200": "#D9F99D",
  "--bds-palette-orange-500": "#F97316",
  "--bds-palette-orange-300": "#FDBA74",
  "--bds-palette-orange-100": "#FFEDD5",
  "--bds-palette-orange-200": "#FED7AA",
  "--bds-palette-pink-500": "#EC4899",
  "--bds-palette-pink-300": "#F9A8D4",
  "--bds-palette-pink-100": "#FCE7F3",
  "--bds-palette-pink-200": "#FBCFE8",
  "--bds-palette-red-500": "#EF4444",
  "--bds-palette-red-300": "#FCA5A5",
  "--bds-palette-red-100": "#FEE2E2",
  "--bds-palette-red-200": "#FECACA",
  "--bds-palette-sky-500": "#0EA5E9",
  "--bds-palette-sky-300": "#7DD3FC",
  "--bds-palette-sky-100": "#E0F2FE",
  "--bds-palette-sky-200": "#BAE6FD",
  "--bds-palette-teal-500": "#14B8A6",
  "--bds-palette-teal-300": "#5EEAD4",
  "--bds-palette-teal-100": "#CCFBF1",
  "--bds-palette-teal-200": "#99F6E4",
  "--bds-palette-violet-500": "#825CF6",
  "--bds-palette-violet-300": "#BDB5FD",
  "--bds-palette-violet-100": "#EDE9FE",
  "--bds-palette-violet-200": "#D9D6FE",
  "--bds-palette-yellow-600": "#CA8A04",
  "--bds-palette-emerald-600": "#059669",
  "--bds-palette-fuchsia-600": "#C026D3",
  "--bds-palette-green-600": "#16A34A",
  "--bds-palette-indigo-600": "#4F46E5",
  "--bds-palette-lime-600": "#65A30D",
  "--bds-palette-orange-600": "#EA580C",
  "--bds-palette-pink-600": "#DB2777",
  "--bds-palette-red-600": "#DC2626",
  "--bds-palette-sky-600": "#0284C7",
  "--bds-palette-teal-600": "#0D9488",
  "--bds-palette-violet-600": "#763AED",
  "--bds-palette-yellow-700": "#A16207",
  "--bds-palette-emerald-700": "#047857",
  "--bds-palette-fuchsia-700": "#A21CAF",
  "--bds-palette-green-700": "#15803D",
  "--bds-palette-indigo-700": "#4338CA",
  "--bds-palette-lime-700": "#4D7C0F",
  "--bds-palette-orange-700": "#C2410C",
  "--bds-palette-pink-700": "#BE185D",
  "--bds-palette-red-700": "#B91C1C",
  "--bds-palette-sky-700": "#0369A1",
  "--bds-palette-teal-700": "#0F766E",
  "--bds-palette-violet-700": "#6928D9",
  "--bds-palette-base-black": "#000000",
  "--bds-palette-base-white": "#FFFFFF",
  "--bds-palette-yellow-50": "#FEFCE8",
  "--bds-palette-neutral-100": "#F3F4F6",
  "--bds-palette-red-900": "#7F1D1D",
  "--bds-palette-red-800": "#991B1B",
  "--bds-palette-yellow-400": "#FACC15",
  "--bds-palette-blue-600": "#2563EB",
  "--bds-palette-blue-100": "#DBEAFE",
  "--bds-color-base-white": "",
  "--bds-palette-alpha-white-600": "#F2F2FA36",
  "--bds-palette-alpha-white-800": "#F5F5FF1A",
  "--bds-palette-alpha-white-700": "#F0F0FF26",
  "--bds-palette-neutral-200": "#E5E7EB",
  "--bds-palette-base-transparent": "#00000000",
  "--bds-palette-alpha-black-200A": "#00062126",
  "--bds-palette-alpha-black-50A": "#00102F0F",
  "--bds-palette-alpha-black-100A": "#060F2E1C",
  "--bds-palette-neutral-900": "#111827",
  "--bds-palette-neutral-700": "#353C4A",
  "--bds-palette-neutral-800": "#1A222E",
  "--bds-palette-alpha-black-75A": "#00092F14",
  "--bds-palette-harborblue-800": "#003F7A",
  "--bds-palette-harborblue-600": "#0A6ECE",
  "--bds-palette-harborblue-700": "#0257A6",
  "--bds-palette-harborblue-200": "#9ED0FF",
  "--bds-palette-harborblue-50": "#E8F4FE",
  "--bds-palette-harborblue-100": "#CCE6FF",
  "--bds-palette-alpha-black-500A": "#00010D8A",
  "--bds-palette-neutral-50": "#F9FAFB",
  "--bds-palette-neutral-300": "#D1D5DB",
  "--bds-palette-neutral-500": "#67707E",
  "--bds-palette-neutral-400": "#A5ABB6",
  "--bds-palette-neutral-600": "#4B5563",
  "--bds-palette-indigo-800": "#3730A3",
  "--bds-palette-yellow-800": "#854D0E",
  "--bds-palette-blue-700": "#1D4ED8",
  "--bds-radius-200": "4px",
  "--bds-radius-300": "6px",
  "--bds-radius-500": "12px",
  "--bds-radius-400": "8px",
  "--bds-radius-full": "360px",
  "--bds-radius-none": "0px",
  "--bds-size-6": "24px",
  "--bds-size-8": "32px",
  "--bds-size-10": "40px",
  "--bds-size-12": "48px",
  "--bds-size-5": "20px",
  "--bds-size-4": "16px",
  "--bds-size-3": "12px",
  "--bds-size-2": "8px",
  "--bds-size-1": "4px",
  "--bds-size-0_5": "2px",
  "--bds-space-6": "24px",
  "--bds-space-8": "32px",
  "--bds-space-10": "40px",
  "--bds-space-12": "48px",
  "--bds-space-4": "16px",
  "--bds-space-3": "12px",
  "--bds-space-2": "8px",
  "--bds-space-5": "20px",
  "--bds-space-1": "4px",
  "--bds-space-0_5": "2px",
  "--bds-elevation-lg": '"0px 0px 0.5px 0px rgba(0, 0, 0, 0.30),  0px 1px 5px 0px rgba(0, 0, 0, 0.15),  0px 10px 24px 0px rgba(0, 0, 0, 0.20),  0px 0.25px 0px 0.25px rgba(0, 0, 0, 0.05) inset,  0px 0px 1px 0px rgba(0, 0, 0, 0.05) inset"',
  "--bds-elevation-md": '"0px 0px 0.5px 0px rgba(0, 0, 0, 0.30),  0px 1px 5px 0px rgba(0, 0, 0, 0.15),  0px 10px 16px 0px rgba(0, 0, 0, 0.10),  0px 0.25px 0px 0.25px rgba(0, 0, 0, 0.05) inset,  0px 0px 1px 0px rgba(0, 0, 0, 0.05) inset"',
  "--bds-elevation-sm": '"0px 0px 0.5px 0px rgba(0, 0, 0, 0.30),  0px 1px 3px 0px rgba(0, 0, 0, 0.15),  0px 5px 12px 0px rgba(0, 0, 0, 0.10),  0px 0.25px 0px 0.25px rgba(0, 0, 0, 0.05) inset,  0px 0px 1px 0px rgba(0, 0, 0, 0.05) inset"',
  "--bds-elevation-xs": '"0px 0px 0.5px 0px rgba(0, 0, 0, 0.30),  0px 1px 3px 0px rgba(0, 0, 0, 0.20),  0px 0.25px 0px 0.25px rgba(0, 0, 0, 0.05) inset,  0px 0px 1px 0px rgba(0, 0, 0, 0.05) inset"',
  "--bds-motion-duration-100": "100ms",
  "--bds-motion-duration-200": "200ms",
  "--bds-motion-timing-100": "14ms",
  "--bds-motion-timing-150": "16ms",
  "--bds-motion-timing-200": "18ms",
  "--bds-motion-timing-250": "20ms",
  "--bds-motion-timing-350": "24ms",
  "--bds-motion-timing-450": "28ms",
  "--bds-motion-timing-50": "12ms",
  "--bds-motion-timing-550": "32ms",
  "--bds-motion-timing-750": "40ms",
  "--bds-motion-timing-900": "56ms",
  "--bds-motion-timing-default": "ease-in-out",
  "--bds-motion-timing-linear": "default",
  "--fh-border-md": "var(--bds-border-200)",
  "--fh-border-sm": "var(--bds-border-100)",
  "--fh-color-accent-bg-amber-default": "var(--bds-palette-yellow-500)",
  "--fh-color-accent-bg-amber-subtle-active": "var(--bds-palette-yellow-300)",
  "--fh-color-accent-bg-amber-subtle-default": "var(--bds-palette-yellow-100)",
  "--fh-color-accent-bg-amber-subtle-hover": "var(--bds-palette-yellow-200)",
  "--fh-color-accent-bg-emerald-default": "var(--bds-palette-emerald-500)",
  "--fh-color-accent-bg-emerald-subtle-active": "var(--bds-palette-emerald-300)",
  "--fh-color-accent-bg-emerald-subtle-default": "var(--bds-palette-emerald-100)",
  "--fh-color-accent-bg-emerald-subtle-hover": "var(--bds-palette-emerald-200)",
  "--fh-color-accent-bg-fuchsia-default": "var(--bds-palette-fuchsia-500)",
  "--fh-color-accent-bg-fuchsia-subtle-active": "var(--bds-palette-fuchsia-300)",
  "--fh-color-accent-bg-fuchsia-subtle-default": "var(--bds-palette-fuchsia-100)",
  "--fh-color-accent-bg-fuchsia-subtle-hover": "var(--bds-palette-fuchsia-200)",
  "--fh-color-accent-bg-green-default": "var(--bds-palette-green-500)",
  "--fh-color-accent-bg-green-subtle-active": "var(--bds-palette-green-300)",
  "--fh-color-accent-bg-green-subtle-default": "var(--bds-palette-green-100)",
  "--fh-color-accent-bg-green-subtle-hover": "var(--bds-palette-green-200)",
  "--fh-color-accent-bg-indigo-default": "var(--bds-palette-indigo-500)",
  "--fh-color-accent-bg-indigo-subtle-active": "var(--bds-palette-indigo-300)",
  "--fh-color-accent-bg-indigo-subtle-default": "var(--bds-palette-indigo-100)",
  "--fh-color-accent-bg-indigo-subtle-hover": "var(--bds-palette-indigo-200)",
  "--fh-color-accent-bg-lime-default": "var(--bds-palette-lime-500)",
  "--fh-color-accent-bg-lime-subtle-active": "var(--bds-palette-lime-300)",
  "--fh-color-accent-bg-lime-subtle-default": "var(--bds-palette-lime-100)",
  "--fh-color-accent-bg-lime-subtle-hover": "var(--bds-palette-lime-200)",
  "--fh-color-accent-bg-orange-default": "var(--bds-palette-orange-500)",
  "--fh-color-accent-bg-orange-subtle-active": "var(--bds-palette-orange-300)",
  "--fh-color-accent-bg-orange-subtle-default": "var(--bds-palette-orange-100)",
  "--fh-color-accent-bg-orange-subtle-hover": "var(--bds-palette-orange-200)",
  "--fh-color-accent-bg-pink-default": "var(--bds-palette-pink-500)",
  "--fh-color-accent-bg-pink-subtle-active": "var(--bds-palette-pink-300)",
  "--fh-color-accent-bg-pink-subtle-default": "var(--bds-palette-pink-100)",
  "--fh-color-accent-bg-pink-subtle-hover": "var(--bds-palette-pink-200)",
  "--fh-color-accent-bg-red-default": "var(--bds-palette-red-500)",
  "--fh-color-accent-bg-red-subtle-active": "var(--bds-palette-red-300)",
  "--fh-color-accent-bg-red-subtle-default": "var(--bds-palette-red-100)",
  "--fh-color-accent-bg-red-subtle-hover": "var(--bds-palette-red-200)",
  "--fh-color-accent-bg-sky-default": "var(--bds-palette-sky-500)",
  "--fh-color-accent-bg-sky-subtle-active": "var(--bds-palette-sky-300)",
  "--fh-color-accent-bg-sky-subtle-default": "var(--bds-palette-sky-100)",
  "--fh-color-accent-bg-sky-subtle-hover": "var(--bds-palette-sky-200)",
  "--fh-color-accent-bg-teal-default": "var(--bds-palette-teal-500)",
  "--fh-color-accent-bg-teal-subtle-active": "var(--bds-palette-teal-300)",
  "--fh-color-accent-bg-teal-subtle-default": "var(--bds-palette-teal-100)",
  "--fh-color-accent-bg-teal-subtle-hover": "var(--bds-palette-teal-200)",
  "--fh-color-accent-bg-violet-default": "var(--bds-palette-violet-500)",
  "--fh-color-accent-bg-violet-subtle-active": "var(--bds-palette-violet-300)",
  "--fh-color-accent-bg-violet-subtle-default": "var(--bds-palette-violet-100)",
  "--fh-color-accent-bg-violet-subtle-hover": "var(--bds-palette-violet-200)",
  "--fh-color-accent-border-amber-default": "var(--bds-palette-yellow-600)",
  "--fh-color-accent-border-emerald-default": "var(--bds-palette-emerald-600)",
  "--fh-color-accent-border-fuchsia-default": "var(--bds-palette-fuchsia-600)",
  "--fh-color-accent-border-green-default": "var(--bds-palette-green-600)",
  "--fh-color-accent-border-indigo-default": "var(--bds-palette-indigo-600)",
  "--fh-color-accent-border-lime-default": "var(--bds-palette-lime-600)",
  "--fh-color-accent-border-orange-default": "var(--bds-palette-orange-600)",
  "--fh-color-accent-border-pink-default": "var(--bds-palette-pink-600)",
  "--fh-color-accent-border-red-default": "var(--bds-palette-red-600)",
  "--fh-color-accent-border-sky-default": "var(--bds-palette-sky-600)",
  "--fh-color-accent-border-teal-default": "var(--bds-palette-teal-600)",
  "--fh-color-accent-border-violet-default": "var(--bds-palette-violet-600)",
  "--fh-color-accent-text-amber-default": "var(--bds-palette-yellow-700)",
  "--fh-color-accent-text-amber-subtle": "var(--bds-palette-yellow-600)",
  "--fh-color-accent-text-emerald-default": "var(--bds-palette-emerald-700)",
  "--fh-color-accent-text-emerald-subtle": "var(--bds-palette-emerald-600)",
  "--fh-color-accent-text-fuchsia-default": "var(--bds-palette-fuchsia-700)",
  "--fh-color-accent-text-fuchsia-subtle": "var(--bds-palette-fuchsia-600)",
  "--fh-color-accent-text-green-default": "var(--bds-palette-green-700)",
  "--fh-color-accent-text-green-subtle": "var(--bds-palette-green-600)",
  "--fh-color-accent-text-indigo-default": "var(--bds-palette-indigo-700)",
  "--fh-color-accent-text-indigo-subtle": "var(--bds-palette-indigo-600)",
  "--fh-color-accent-text-lime-default": "var(--bds-palette-lime-700)",
  "--fh-color-accent-text-lime-subtle": "var(--bds-palette-lime-600)",
  "--fh-color-accent-text-orange-default": "var(--bds-palette-orange-700)",
  "--fh-color-accent-text-orange-subtle": "var(--bds-palette-orange-600)",
  "--fh-color-accent-text-pink-default": "var(--bds-palette-pink-700)",
  "--fh-color-accent-text-pink-subtle": "var(--bds-palette-pink-600)",
  "--fh-color-accent-text-red-default": "var(--bds-palette-red-700)",
  "--fh-color-accent-text-red-subtle": "var(--bds-palette-red-600)",
  "--fh-color-accent-text-sky-default": "var(--bds-palette-sky-700)",
  "--fh-color-accent-text-sky-subtle": "var(--bds-palette-sky-600)",
  "--fh-color-accent-text-teal-default": "var(--bds-palette-teal-700)",
  "--fh-color-accent-text-teal-subtle": "var(--bds-palette-teal-600)",
  "--fh-color-accent-text-violet-default": "var(--bds-palette-violet-700)",
  "--fh-color-accent-text-violet-subtle": "var(--bds-palette-violet-600)",
  "--fh-color-base-black": "var(--bds-palette-base-black)",
  "--fh-color-base-white": "var(--bds-palette-base-white)",
  "--fh-color-bg-callout-default": "var(--bds-palette-yellow-50)",
  "--fh-color-bg-disabled": "var(--bds-palette-neutral-100)",
  "--fh-color-bg-error-active": "var(--bds-palette-red-900)",
  "--fh-color-bg-error-default": "var(--bds-palette-red-700)",
  "--fh-color-bg-error-hover": "var(--bds-palette-red-800)",
  "--fh-color-bg-error-subtle-active": "var(--bds-palette-red-200)",
  "--fh-color-bg-error-subtle-default": "var(--bds-palette-red-100)",
  "--fh-color-bg-error-subtle-hover": "var(--bds-palette-red-200)",
  "--fh-color-bg-highlight-default": "var(--bds-palette-violet-600)",
  "--fh-color-bg-highlight-subtle-default": "var(--bds-palette-violet-100)",
  "--fh-color-bg-hint-default": "var(--bds-palette-yellow-400)",
  "--fh-color-bg-hint-subtle-default": "var(--bds-palette-yellow-100)",
  "--fh-color-bg-information-default": "var(--bds-palette-blue-600)",
  "--fh-color-bg-information-subtle-default": "var(--bds-palette-blue-100)",
  "--fh-color-bg-input-active": "var(--bds-color-base-white)",
  "--fh-color-bg-input-default": "var(--bds-palette-base-white)",
  "--fh-color-bg-input-hover": "var(--bds-color-base-white)",
  "--fh-color-bg-inverted-active": "var(--bds-palette-alpha-white-600)",
  "--fh-color-bg-inverted-default": "var(--bds-palette-alpha-white-800)",
  "--fh-color-bg-inverted-hover": "var(--bds-palette-alpha-white-700)",
  "--fh-color-bg-inverted-strong-active": "var(--bds-palette-neutral-200)",
  "--fh-color-bg-inverted-strong-default": "var(--bds-palette-base-white)",
  "--fh-color-bg-inverted-strong-hover": "var(--bds-palette-neutral-100)",
  "--fh-color-bg-inverted-subtle-active": "var(--bds-palette-alpha-white-700)",
  "--fh-color-bg-inverted-subtle-default": "var(--bds-palette-base-transparent)",
  "--fh-color-bg-inverted-subtle-hover": "var(--bds-palette-alpha-white-800)",
  "--fh-color-bg-neutral-active": "var(--bds-palette-alpha-black-200A)",
  "--fh-color-bg-neutral-default": "var(--bds-palette-alpha-black-50A)",
  "--fh-color-bg-neutral-hover": "var(--bds-palette-alpha-black-100A)",
  "--fh-color-bg-neutral-strong-active": "var(--bds-palette-neutral-900)",
  "--fh-color-bg-neutral-strong-default": "var(--bds-palette-neutral-700)",
  "--fh-color-bg-neutral-strong-hover": "var(--bds-palette-neutral-800)",
  "--fh-color-bg-neutral-subtle-active": "var(--bds-palette-alpha-black-75A)",
  "--fh-color-bg-neutral-subtle-default": "var(--bds-palette-base-transparent)",
  "--fh-color-bg-neutral-subtle-hover": "var(--bds-palette-alpha-black-50A)",
  "--fh-color-bg-primary-active": "var(--bds-palette-harborblue-800)",
  "--fh-color-bg-primary-default": "var(--bds-palette-harborblue-600)",
  "--fh-color-bg-primary-hover": "var(--bds-palette-harborblue-700)",
  "--fh-color-bg-primary-subtle-active": "var(--bds-palette-harborblue-200)",
  "--fh-color-bg-primary-subtle-default": "var(--bds-palette-harborblue-50)",
  "--fh-color-bg-primary-subtle-hover": "var(--bds-palette-harborblue-100)",
  "--fh-color-bg-secondary-active": "var(--bds-palette-alpha-black-100A)",
  "--fh-color-bg-secondary-default": "var(--bds-palette-alpha-black-50A)",
  "--fh-color-bg-secondary-hover": "var(--bds-palette-alpha-black-75A)",
  "--fh-color-bg-success-default": "var(--bds-palette-green-700)",
  "--fh-color-bg-success-subtle-default": "var(--bds-palette-green-100)",
  "--fh-color-bg-surface-default": "var(--bds-palette-base-white)",
  "--fh-color-bg-surface-overlay": "var(--bds-palette-base-white)",
  "--fh-color-bg-surface-overlay-scrim": "var(--bds-palette-alpha-black-500A)",
  "--fh-color-bg-surface-raised": "var(--bds-palette-base-white)",
  "--fh-color-bg-surface-subtle": "var(--bds-palette-neutral-50)",
  "--fh-color-bg-warning-default": "var(--bds-palette-orange-700)",
  "--fh-color-bg-warning-subtle-default": "var(--bds-palette-orange-100)",
  "--fh-color-border-alpha": "var(--bds-palette-alpha-black-75A)",
  "--fh-color-border-default": "var(--bds-palette-neutral-300)",
  "--fh-color-border-disabled": "var(--bds-palette-neutral-200)",
  "--fh-color-border-error-default": "var(--bds-palette-red-600)",
  "--fh-color-border-error-subtle-default": "var(--bds-palette-red-300)",
  "--fh-color-border-highlight-default": "var(--bds-palette-violet-600)",
  "--fh-color-border-hint-default": "var(--bds-palette-yellow-600)",
  "--fh-color-border-information-default": "var(--bds-palette-blue-600)",
  "--fh-color-border-input-active": "var(--bds-palette-neutral-500)",
  "--fh-color-border-input-default": "var(--bds-palette-neutral-400)",
  "--fh-color-border-input-hover": "var(--bds-palette-neutral-500)",
  "--fh-color-border-inverted": "var(--bds-palette-base-white)",
  "--fh-color-border-neutral-default": "var(--bds-palette-neutral-600)",
  "--fh-color-border-primary-default": "var(--bds-palette-harborblue-600)",
  "--fh-color-border-primary-subtle": "var(--bds-palette-harborblue-100)",
  "--fh-color-border-secondary-default": "var(--bds-palette-base-transparent)",
  "--fh-color-border-secondary-inverted": "var(--bds-palette-base-transparent)",
  "--fh-color-border-strong": "var(--bds-palette-neutral-500)",
  "--fh-color-border-subtle": "var(--bds-palette-neutral-200)",
  "--fh-color-border-success-default": "var(--bds-palette-green-600)",
  "--fh-color-border-warning-default": "var(--bds-palette-orange-600)",
  "--fh-color-focus-default": "var(--bds-palette-blue-600)",
  "--fh-color-focus-inverted": "var(--bds-palette-base-white)",
  "--fh-color-graph-color1-default": "var(--bds-palette-harborblue-600)",
  "--fh-color-graph-color1-hover": "var(--bds-palette-harborblue-700)",
  "--fh-color-graph-color1-subtle-default": "var(--bds-palette-harborblue-100)",
  "--fh-color-graph-color2-default": "var(--bds-palette-pink-600)",
  "--fh-color-graph-color2-hover": "var(--bds-palette-pink-700)",
  "--fh-color-graph-color2-subtle-default": "var(--bds-palette-pink-100)",
  "--fh-color-graph-color3-default": "var(--bds-palette-emerald-600)",
  "--fh-color-graph-color3-hover": "var(--bds-palette-emerald-700)",
  "--fh-color-graph-color3-subtle-default": "var(--bds-palette-emerald-100)",
  "--fh-color-graph-color4-default": "var(--bds-palette-orange-600)",
  "--fh-color-graph-color4-hover": "var(--bds-palette-orange-700)",
  "--fh-color-graph-color4-subtle-default": "var(--bds-palette-orange-100)",
  "--fh-color-graph-color5-default": "var(--bds-palette-indigo-700)",
  "--fh-color-graph-color5-hover": "var(--bds-palette-indigo-800)",
  "--fh-color-graph-color5-subtle-default": "var(--bds-palette-indigo-100)",
  "--fh-color-graph-neutral": "var(--bds-palette-neutral-200)",
  "--fh-color-icon-default": "var(--bds-palette-neutral-800)",
  "--fh-color-icon-disabled": "var(--bds-palette-neutral-400)",
  "--fh-color-icon-error-default": "var(--bds-palette-red-700)",
  "--fh-color-icon-highlight-default": "var(--bds-palette-violet-700)",
  "--fh-color-icon-hint-default": "var(--bds-palette-yellow-800)",
  "--fh-color-icon-hint-inverted": "var(--bds-palette-neutral-800)",
  "--fh-color-icon-information-default": "var(--bds-palette-blue-700)",
  "--fh-color-icon-inverted": "var(--bds-palette-base-white)",
  "--fh-color-icon-primary-active": "var(--bds-palette-harborblue-800)",
  "--fh-color-icon-primary-default": "var(--bds-palette-harborblue-600)",
  "--fh-color-icon-primary-hover": "var(--bds-palette-harborblue-700)",
  "--fh-color-icon-subtle": "var(--bds-palette-neutral-500)",
  "--fh-color-icon-success-default": "var(--bds-palette-green-700)",
  "--fh-color-icon-warning-default": "var(--bds-palette-orange-700)",
  "--fh-color-icon-warning-inverted": "var(--bds-palette-neutral-800)",
  "--fh-color-text-default": "var(--bds-palette-neutral-800)",
  "--fh-color-text-disabled": "var(--bds-palette-neutral-400)",
  "--fh-color-text-error-default": "var(--bds-palette-red-700)",
  "--fh-color-text-highlight-default": "var(--bds-palette-violet-700)",
  "--fh-color-text-hint-default": "var(--bds-palette-yellow-800)",
  "--fh-color-text-hint-inverted": "var(--bds-palette-neutral-800)",
  "--fh-color-text-information-default": "var(--bds-palette-blue-700)",
  "--fh-color-text-inverted": "var(--bds-palette-base-white)",
  "--fh-color-text-primary-active": "var(--bds-palette-harborblue-800)",
  "--fh-color-text-primary-default": "var(--bds-palette-harborblue-600)",
  "--fh-color-text-primary-hover": "var(--bds-palette-harborblue-700)",
  "--fh-color-text-subtle": "var(--bds-palette-neutral-500)",
  "--fh-color-text-success-default": "var(--bds-palette-green-700)",
  "--fh-color-text-warning-default": "var(--bds-palette-orange-700)",
  "--fh-radius-component-badge": "var(--bds-radius-200)",
  "--fh-radius-component-button": "var(--bds-radius-300)",
  "--fh-radius-component-card": "var(--bds-radius-500)",
  "--fh-radius-component-input": "var(--bds-radius-300)",
  "--fh-radius-component-table": "var(--bds-radius-400)",
  "--fh-radius-full": "var(--bds-radius-full)",
  "--fh-radius-lg": "var(--bds-radius-400)",
  "--fh-radius-md": "var(--bds-radius-300)",
  "--fh-radius-none": "var(--bds-radius-none)",
  "--fh-radius-sm": "var(--bds-radius-200)",
  "--fh-radius-xl": "var(--bds-radius-500)",
  "--fh-size-2xl": "var(--bds-size-6)",
  "--fh-size-3xl": "var(--bds-size-8)",
  "--fh-size-4xl": "var(--bds-size-10)",
  "--fh-size-5xl": "var(--bds-size-12)",
  "--fh-size-icon-lg": "var(--bds-size-6)",
  "--fh-size-icon-md": "var(--bds-size-5)",
  "--fh-size-icon-sm": "var(--bds-size-4)",
  "--fh-size-icon-xs": "var(--bds-size-3)",
  "--fh-size-lg": "var(--bds-size-4)",
  "--fh-size-md": "var(--bds-size-3)",
  "--fh-size-sm": "var(--bds-size-2)",
  "--fh-size-xl": "var(--bds-size-5)",
  "--fh-size-xs": "var(--bds-size-1)",
  "--fh-size-xxs": "var(--bds-size-0_5)",
  "--fh-space-2xl": "var(--bds-space-6)",
  "--fh-space-3xl": "var(--bds-space-8)",
  "--fh-space-4xl": "var(--bds-space-10)",
  "--fh-space-5xl": "var(--bds-space-12)",
  "--fh-space-lg": "var(--bds-space-4)",
  "--fh-space-md": "var(--bds-space-3)",
  "--fh-space-sm": "var(--bds-space-2)",
  "--fh-space-xl": "var(--bds-space-5)",
  "--fh-space-xs": "var(--bds-space-1)",
  "--fh-space-xxs": "var(--bds-space-0_5)",
  "--fh-typography-font-family-default": '"Roboto-Beacon"',
  "--fh-typography-font-family-mono": "monospace",
  "--fh-typography-font-line-height-100": "14px",
  "--fh-typography-font-line-height-1150": "56px",
  "--fh-typography-font-line-height-150": "16px",
  "--fh-typography-font-line-height-200": "18px",
  "--fh-typography-font-line-height-250": "20px",
  "--fh-typography-font-line-height-350": "24px",
  "--fh-typography-font-line-height-450": "28px",
  "--fh-typography-font-line-height-50": "12px",
  "--fh-typography-font-line-height-550": "32px",
  "--fh-typography-font-line-height-650": "36px",
  "--fh-typography-font-line-height-750": "40px",
  "--fh-typography-font-line-height-850": "44px",
  "--fh-typography-font-size-100": "14px",
  "--fh-typography-font-size-150": "16px",
  "--fh-typography-font-size-200": "18px",
  "--fh-typography-font-size-250": "20px",
  "--fh-typography-font-size-350": "24px",
  "--fh-typography-font-size-450": "28px",
  "--fh-typography-font-size-50": "12px",
  "--fh-typography-font-size-550": "32px",
  "--fh-typography-font-size-750": "40px",
  "--fh-typography-font-size-900": "56px",
  "--fh-typography-font-weight-bold": 700,
  "--fh-typography-font-weight-medium": 500,
  "--fh-typography-font-weight-regular": 400,
  "--fh-typography-letter-spacing-default": "normal",
  "--fh-typography-letter-spacing-tight": "-0.4px",
  "--fh-elevation-lg": "0px 0px 0.5px 0px rgba(0, 0, 0, 0.30),  0px 1px 5px 0px rgba(0, 0, 0, 0.15),  0px 10px 24px 0px rgba(0, 0, 0, 0.20),  0px 0.25px 0px 0.25px rgba(0, 0, 0, 0.05) inset,  0px 0px 1px 0px rgba(0, 0, 0, 0.05) inset",
  "--fh-elevation-md": "0px 0px 0.5px 0px rgba(0, 0, 0, 0.30),  0px 1px 5px 0px rgba(0, 0, 0, 0.15),  0px 10px 16px 0px rgba(0, 0, 0, 0.10),  0px 0.25px 0px 0.25px rgba(0, 0, 0, 0.05) inset,  0px 0px 1px 0px rgba(0, 0, 0, 0.05) inset",
  "--fh-elevation-sm": "0px 0px 0.5px 0px rgba(0, 0, 0, 0.30),  0px 1px 3px 0px rgba(0, 0, 0, 0.15),  0px 5px 12px 0px rgba(0, 0, 0, 0.10),  0px 0.25px 0px 0.25px rgba(0, 0, 0, 0.05) inset,  0px 0px 1px 0px rgba(0, 0, 0, 0.05) inset",
  "--fh-elevation-xs": "0px 0px 0.5px 0px rgba(0, 0, 0, 0.30),  0px 1px 3px 0px rgba(0, 0, 0, 0.20),  0px 0.25px 0px 0.25px rgba(0, 0, 0, 0.05) inset,  0px 0px 1px 0px rgba(0, 0, 0, 0.05) inset"
};
export {
  fareharborTheme as f
};
//# sourceMappingURL=fareharborLight.theme-DSq3ijTc.js.map
